import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../utils';
import type { ListGeneralSettingQuery, ListGeneralSettingQueryVariables } from '../../graphql/API';
import { listGeneralSetting } from '../../graphql';

export const voucherSettingsApiv2 = createApi({
  reducerPath: 'voucherSettingsApiv2',
  baseQuery,
  tagTypes: ['listGeneralSettings'],
  endpoints: (builder) => ({
    //  List General Settings
    listGeneralSetting: builder.query<ListGeneralSettingQuery, ListGeneralSettingQueryVariables>({
      query: (variables) => ({
        body: listGeneralSetting,
        variables,
      }),
      keepUnusedDataFor: Infinity,
      providesTags: (result, error, { entrytypecd }) => [
        { type: 'listGeneralSettings', id: entrytypecd },
        { type: 'listGeneralSettings', id: 'ALL' },
      ],
    }),
  }),
});

export const { useListGeneralSettingQuery } = voucherSettingsApiv2;
